export const SeminarContentCardQuestions = [
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The knowledge and skills shared were relevant and useful.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: true,
        eventQuestion: "The amount of material presented in this programme was just right.",
        eventQuestionTypeId: 2,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "1. Strong Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "2. Disagree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "3. Neutral",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "4. Agree",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "5. Strong Agree",
                "isOther": false
            },
        ],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Which part of the Seminar did you enjoy the most?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Which part of the Seminar do you think could be improved?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "What other areas would you have liked to be covered?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "What other comments or suggestions do you have for this Seminar?",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Let us know who you would like to be connected with to further the conversation.",
        eventQuestionTypeId: 3,
        isFeedbackQuestion: true,
        answers: [
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Speaker 1, Organisation",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Speaker 2, Organisation",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Speaker 3, Organisation",
                "isOther": false
            },
            {
                "eventQuestionAnswerId": 0,
                "eventQuestionId": 0,
                "eventQuestionAnswer": "Speaker 4, Organisation",
                "isOther": false
            },
        ],
        isOther: false,
    },
    // {
    //     eventQuestionId: 0,
    //     eventId: 0,
    //     isMandatoryQuestion: false,
    //     eventQuestion: "Speaker 1, Organisation",
    //     eventQuestionTypeId: 1,
    //     isFeedbackQuestion: true,
    //     answers: [],
    //     isOther: false,
    // },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "If you would like to be connected with our speakers,please fill in your details.",
        eventQuestionTypeId: 17,
        isFeedbackQuestion: false,
        answers: [],
        isOther: false,
        placeholder: "If you would like to be connected with our speakers,please fill in your details."
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Name",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Organisation",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
    {
        eventQuestionId: 0,
        eventId: 0,
        isMandatoryQuestion: false,
        eventQuestion: "Email Address",
        eventQuestionTypeId: 1,
        isFeedbackQuestion: true,
        answers: [],
        isOther: false,
    },
]